import { useContext } from 'react';

import LayoutEntityUpdateAlertContext, { LayoutEntityUpdateAlertValues } from './context';

const useLayoutEntityUpdateAlert = (): LayoutEntityUpdateAlertValues =>
  useContext(LayoutEntityUpdateAlertContext);

export default useLayoutEntityUpdateAlert;
